import { render, staticRenderFns } from "./CardProductStore.vue?vue&type=template&id=0ee54be4&"
import script from "./CardProductStore.vue?vue&type=script&lang=js&"
export * from "./CardProductStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports